import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DireccionSocioSelect } from 'sharedComponents/select'

const DireccionSocioFormGroup = ({ vIdSocio, iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const oneRowTrigger = React.useCallback(
    row => {
      setFieldValue('_idDireccion', row._id)
    },
    [setFieldValue]
  )

  const seleccionarDireccionCreadaHandler = React.useCallback(
    ({ _id }, closeModal, refreshSelect) => {
      refreshSelect().then(() => {
        setFieldValue('_idDireccion', _id)
        closeModal()
      })
    },
    [setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='DIRECCIÓN' htmlFor='select-idDireccionSocio' md={4} alignRightAt='md' />
        <Col md={8}>
          <Field name='_idDireccion'>
            {({ field }) => (
              <DireccionSocioSelect
                {...field}
                idSocio={vIdSocio}
                onCreate={seleccionarDireccionCreadaHandler}
                showNewButton
                oneRowTrigger={oneRowTrigger}
                id='select-idDireccionSocio'
                isInvalid={iTouched && iError}
                disabled={fIsSubmitting || vIdSocio === ''}
              />
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(DireccionSocioFormGroup)
